import { IconLibrary } from '@product-framework/index';

const RescheduleHelper = {
  getBreadcrumb: ({ formatMessage, navigate, store, serviceJob }) => {
    return [
      {
        name: formatMessage({
          id: 'DASHBOARD',
          defaultMessage: 'Dashboard',
        }),
        icon: IconLibrary.Dashboard,
        onClick: () => {
          navigate('/dashboard');
        },
      },
      {
        name: formatMessage({
          id: 'JOBS',
          defaultMessage: 'Jobs',
        }),
        permissionName: 'LIST_JOBS',
        icon: IconLibrary.ServiceJobs,
        onClick: () => {
          store.domain.list.reset('ServiceJobList');
          navigate('/servicejobs');
        },
      },
      {
        name: formatMessage(
          {
            id: 'JOB_BRACKET_SERVICE_JOB_NUMBER',
            defaultMessage: 'Job ({serviceJobNumber})',
          },
          {
            serviceJobNumber: serviceJob.serviceJobNumber,
          },
        ),
        icon: IconLibrary.ServiceJob,
        onClick: undefined,
      },
    ];
  },
  getStackableButton: ({ formatMessage, serviceJob, navigate }) => {
    return [
      {
        label: formatMessage(
          {
            id: 'JOB_COLON_SERVICE_JOB_NUMBER',
            defaultMessage: 'Job: {serviceJobNumber}',
          },
          { serviceJobNumber: serviceJob?.serviceJobNumber },
        ),
        Icon: IconLibrary.Back,
        variant: 'outlined',
        onClick: () => {
          navigate(`/servicejobs/edit/${serviceJob?.id}`);
        },
      },
    ];
  },
  returnToJobPage: serviceJob => {
    window.location.href = `/servicejobs/edit/${serviceJob?.id}`;
  },
  fetchCalendarData: async ({
    dated,
    serviceProviderId,
    excludeServiceProviderId,
    getApiUrl,
    serviceJob,
    get,
  }) => {
    const url = `${getApiUrl()}/sxcl/v1/availability/service-job/${serviceJob?.id}/schedule-calendar`;
    const response = await get(url, {
      date: dated,
      days: 30,
      ...(serviceProviderId && { serviceProviderId }),
      ...(excludeServiceProviderId && { excludeServiceProviderId }),
    });
    return response;
  },
};

export default RescheduleHelper;
